export const environment = {
  production: true,
  // apiUrl: 'https://uat-vat-api.pramernraka.com',
  // apiUrlDirect: 'https://uat-vat-api.pramernraka.com',
  apiUrl: 'https://api.vatthai.or.th',
  apiUrlDirect: 'https://api.vatthai.or.th',
  name: 'uat'
}; 
